import React, { useEffect, useState } from "react";
import Http from "../../../Common/Http";

const ReceipeDetail = (props) => {
  const [unit, setUnit] = useState();
  let options = [];
  if (props.listInfo != undefined) {
    options.push({ value: "", info: "Select RMPM" });
    Object.keys(props.listInfo).forEach((key) => {
      options.push({
        value: props.listInfo[key],
        info: props.listInfo[key],
        selected: props.selected,
      });
    });
  } else {
    options.push({
      value: "",
      info: "No RMPM Found",
      selected: null,
    });
  }
  const removeList = (index) => {
    props.remove(index);
  };
  const handleInputChange = (e, index) => {
    props.listInputChange(e, index);
  };

  console.log(props)

  // useEffect(()=>{
  //   fetchUnitData(props.listInfo.id)
  // })

  // const fetchUnitData = async (id) => {
  //   if(id){
  //     const response = await Http.get(`/product/${id}`);
  //     setUnit(response.data);
  //   }
    
  // }

  const [displayErrorMessage, setDisplayErrorMessage] = useState();

  const handleNumberInputChange = (e,index) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      props.listInputChange(e, index);
      setDisplayErrorMessage('');
    } else {
      setDisplayErrorMessage('Only numbers are allowed!');
    }
  };


  return (
    <tr>
      <td>{props.listInfo.code}</td>
      <td>{props.listInfo.name}</td>
      {!props.hideStandardQty && (
        <td className="text-right">
          <p style={{ padding: "7px 0px", marginBottom: "0px" }}>
            {props.listInfo.stndrd_qty ? props.listInfo.stndrd_qty : 0}
          </p>
        </td>
      )}
      <td>
        <>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              name="issue_qty"
              onChange={(e) => handleNumberInputChange(e, props.listSl)}
              value={props.listInfo.issue_qty || props.listInfo.stndrd_qty}
              onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
            />
            {/* <span className="input-group-text">{props.listInfo?.unit?.name}</span> */}
          </div>
          {/* {displayErrorMessage && <div className="text-danger mt-1">{displayErrorMessage}</div>} */}
          {!props.hideStandardQty && (
            <p
              style={{
                color: "red",
                textAlign: "center",
                marginTop: "2px",
                marginBottom: "2px",
              }}
            >
              {props.listInfo.issue_qty < 0.01 && props.listInfo.stndrd_qty < 0.01
                ? "0 Are Not Allowed"
                : ""}
            </p>
          )}
        </>
      </td>
      <td className="text-center">
        <button
          className="btn btn-danger btn-sm"
          onClick={() => removeList(props.listSl)}
        >
          <i className="fa fa-trash"></i> Delete
        </button>
      </td>
    </tr>
  );
};

export default ReceipeDetail;
